
export default {
  name: 'BlocksProTip',
  // No props needed — content comes through the slot
}
